import { AssigneeType } from '@enums/assignee-type.enum';
import { joinDuration, nowRoundedDown, parseDate, parseTime, splitDuration } from './formatters';
import { t as translate } from './translate';
import { SeriesScope, VisitPriority } from './types';
export const DEFAULT_DURATION_MINUTES = 120;
export function ianaFor(timeZone, options, defaults) {
    var _a;
    const fromOptions = (_a = options === null || options === void 0 ? void 0 : options.find((option) => option.value === timeZone)) === null || _a === void 0 ? void 0 : _a.iana;
    return fromOptions !== null && fromOptions !== void 0 ? fromOptions : (timeZone === defaults.timeZone ? defaults.timeZoneIana : undefined);
}
export function newDraft({ defaults, formDefaults, timeZoneOptions }) {
    const timeZone = formDefaults.timeZone || defaults.timeZone;
    const duration = splitDuration(DEFAULT_DURATION_MINUTES);
    return {
        assigneeType: AssigneeType.TECHNICIAN,
        technicianId: defaults.technicianId,
        subcontractorId: null,
        timeZone,
        scheduledDate: defaults.scheduledDate || formDefaults.scheduledDate || '',
        scheduledTime: nowRoundedDown(ianaFor(timeZone, timeZoneOptions, defaults)),
        days: String(duration.days),
        hours: String(duration.hours),
        minutes: String(duration.minutes),
        priority: VisitPriority.NORMAL,
        priorityNote: '',
        visitNotes: '',
        updateAll: SeriesScope.THIS_ONLY
    };
}
export function draftFromRow(row) {
    var _a;
    const duration = splitDuration(row.duration);
    return {
        assigneeType: row.assigneeType,
        technicianId: row.technicianId,
        subcontractorId: row.subcontractorId,
        timeZone: row.timeZone,
        scheduledDate: row.scheduledDate,
        scheduledTime: row.scheduledTime,
        days: String(duration.days),
        hours: String(duration.hours),
        minutes: String(duration.minutes),
        priority: (_a = row.priority) !== null && _a !== void 0 ? _a : VisitPriority.NORMAL,
        priorityNote: row.priorityNote,
        visitNotes: row.visitNotes,
        updateAll: SeriesScope.THIS_ONLY
    };
}
const WHOLE_NUMBER = /^\d+$/;
const toNumber = (value) => (value === '' ? 0 : Number(value));
export function draftDurationMinutes(draft) {
    return joinDuration({ days: toNumber(draft.days), hours: toNumber(draft.hours), minutes: toNumber(draft.minutes) });
}
export function validateDraft(draft) {
    const errors = {};
    if (!parseDate(draft.scheduledDate))
        errors.scheduledDate = translate('required');
    if (!parseTime(draft.scheduledTime))
        errors.scheduledTime = translate('required');
    ['days', 'hours', 'minutes'].forEach((field) => {
        if (draft[field] !== '' && !WHOLE_NUMBER.test(draft[field]))
            errors[field] = translate('invalid_number');
    });
    return errors;
}
export function draftToValues(draft) {
    const isHigh = draft.priority === VisitPriority.HIGH;
    return {
        assigneeType: draft.assigneeType,
        technicianId: draft.assigneeType === AssigneeType.TECHNICIAN ? draft.technicianId : null,
        subcontractorId: draft.assigneeType === AssigneeType.SUBCONTRACTOR ? draft.subcontractorId : null,
        scheduledDate: draft.scheduledDate,
        scheduledTime: draft.scheduledTime,
        timeZone: draft.timeZone,
        duration: draftDurationMinutes(draft),
        priority: draft.priority,
        priorityNote: isHigh ? draft.priorityNote : '',
        visitNotes: draft.visitNotes,
        updateAll: draft.updateAll
    };
}
/** The row fields a submit stages in form mode. */
export function rowFieldsFromValues(values) {
    return {
        assigneeType: values.assigneeType,
        technicianId: values.technicianId,
        subcontractorId: values.subcontractorId,
        scheduledDate: values.scheduledDate,
        scheduledTime: values.scheduledTime,
        timeZone: values.timeZone,
        duration: values.duration,
        priority: values.priority,
        priorityNote: values.priorityNote,
        visitNotes: values.visitNotes
    };
}
